<app-language-selector aria-label="Language menu" class="tool-bar__language" />
<app-profile-selector aria-label="User menu" class="tool-bar__profile" />

<button (click)="onClickToggleMenu()" class="btn tool-bar__menu">
  @if (!isMenuOpen()) {
    <img class="tool-bar__menu-img tool-bar__menu-img--reduced" src="resources/img/icons/hamburger-menu.png" alt="Menu icon" />
  } @else {
    <img class="tool-bar__menu-img tool-bar__menu-img--reduced" src="resources/img/icons/close.png" alt="Close icon" />
  }
</button>
